import { ICustomerSalesRatioVM } from "../../models/response/ITotallingManagementResponse";

export const initialCustomerSalesRatioAccordingToAgeGroupData = {
  NumberOfPeopleMale: 0,
  NumberOfPeopleMalePercentage: 0,
  AverageCustomerSpendingMale: 0,
  NumberOfPeopleFemale: 0,
  NumberOfPeopleFemalePercentage: 0,
  AverageCustomerSpendingFemale: 0,
  NumberOfPeopleNotSet: 0,
  NumberOfPeopleNotSetPercentage: 0,
  AverageCustomerSpendingNotSet: 0,
}
export const customerSalesRatioInitialState: ICustomerSalesRatioVM = {
    Under10Year: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    Teenager: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    Twenties: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    Thirties: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    Forties: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    Fifties: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    Sixties: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    Seventies: {...initialCustomerSalesRatioAccordingToAgeGroupData},
    NotSpecified: {...initialCustomerSalesRatioAccordingToAgeGroupData},
};